var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nav"}},[_c('div',{staticClass:"item"},[_vm._v(" Candidato ")]),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":_vm.apiUrl,"target":"_blank"}},[_vm._v("Versão: "+_vm._s(_vm.version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }